import { media } from '@payright/web-components';
import styled from 'styled-components';

export const SCCustomerDetails = styled.div`
  background: ${(props) => props.theme.colours.white};
  hr {
    border-style: solid;
    border-bottom: none;
    border-color: ${(props) => props.theme.colours.grey.altlight};
    margin: 1em 0;
  }

  .expense-body {
    max-width: 800px;
    width: 100%;
    margin: 4rem auto 3rem;

    ${media.max.medium} {
      margin: 1.6rem auto 0;
    }
    ${media.max.ewide} {
      padding: 0 1.6rem;
    }

    h4 {
      color: ${(props) => props.theme.colours.blue.base};
    }
  }

  .alert-container {
    margin-bottom: 3rem;
  }

  .expense-buttons {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    padding-bottom: 30px;

    button {
      width: 100%;
    }
  }

  .section-intro {
    margin-right: 0;
  }

  .section-intro,
  section-content {
    flex-basis: 0;
  }
`;
